<script type="ts">
	import Avatar from '$Chat/Avatar.svelte';
	import type { AchordData } from 'src/app';

	export let author: AchordData.Profile;
	export let content: string;
	export let time: string;
</script>

<div class="message">
	<div class="avatar"><Avatar name={author.avatar} /></div>
	<div class="author">{author.name}</div>
	<div class="text">{@html content}</div>
	<div class="time">{time}</div>
</div>

<style lang="scss">
	.message {
		padding: 18px;
		display: grid;
		grid-template:
			'avatar author time'
			'avatar text text'
			/ 40px auto 1fr;
		grid-gap: 7px;
		grid-row-gap: 4.3px;
		align-items: start;

		&:hover {
			background-color: hsl(0 0% 50% / 0.04);
		}
	}
	.avatar {
		grid-area: avatar;
	}
	.author,
	.time {
		line-height: 1;
		align-self: baseline;
	}
	.author {
		font-weight: bold;
		grid-area: author;
	}
	.text {
		grid-area: text;
		line-height: 1.44;
	}
	.time {
		font-size: 0.8em;
		grid-area: time;
		color: var(--demo-text-low);
	}

	.message .text {
		:global(code) {
			font-family: monospace;
			font-size: 0.85em;
			padding: 3px 5px;
			border-radius: 5px;
			background-color: var(--demo-bg-20);
			color: hsl(210, 55%, 85%);
		}
	}
</style>
